export const getToastOptions = (dispatch, action) => {
    return {
        onOpen: props => dispatch(action.storeToastStatus(true)),
        onClose: props => dispatch(action.storeToastStatus(false)),     
    };
}